import { PUBLIC_SITE_URL } from "./site";

export const DURI_ORG_ID = `${PUBLIC_SITE_URL}/#organization`;
export const DURI_WEBSITE_ID = `${PUBLIC_SITE_URL}/#website`;

export const DURI_SAME_AS = [
  "https://duriapp.com",
  "https://play.google.com/store/apps/details?id=com.hst.duriapp",
  "https://apps.apple.com/in/app/duri/id6755706995",
  "https://twitter.com/DuriApp",
] as const;

export const DURI_CONTACT_POINTS = [
  {
    "@type": "ContactPoint" as const,
    contactType: "customer support",
    email: "support@duriapp.com",
    telephone: "+91-7680938741",
    availableLanguage: ["English", "Hindi", "Telugu"],
    areaServed: "IN",
  },
  {
    "@type": "ContactPoint" as const,
    contactType: "customer support",
    url: "https://wa.me/917680938741",
    availableLanguage: ["English", "Hindi", "Telugu"],
    areaServed: "IN",
  },
];

export function buildOrganizationNode(options?: { includeContact?: boolean }) {
  const node: Record<string, unknown> = {
    "@type": "Organization",
    "@id": DURI_ORG_ID,
    name: "Duri Ridesharing",
    alternateName: "Duri",
    url: `${PUBLIC_SITE_URL}/`,
    logo: `${PUBLIC_SITE_URL}/favicon.ico`,
    sameAs: [...DURI_SAME_AS],
  };
  if (options?.includeContact) {
    node.contactPoint = DURI_CONTACT_POINTS;
  }
  return node;
}

export function buildWebSiteNode() {
  return {
    "@type": "WebSite",
    "@id": DURI_WEBSITE_ID,
    url: `${PUBLIC_SITE_URL}/`,
    name: "Duri Ridesharing",
    description:
      "Trusted ridesharing app for intercity travel, intracity trips, and daily commute carpool in India.",
    publisher: { "@id": DURI_ORG_ID },
    inLanguage: "en-IN",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${PUBLIC_SITE_URL}/available-rides?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
}
